var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuatrefoil = function SvgQuatrefoil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C9.419 0 7.26 2.138 7.26 4.74a2.574 2.574 0 0 1-2.562 2.562A4.706 4.706 0 0 0 0 12a4.7 4.7 0 0 0 4.698 4.698A2.574 2.574 0 0 1 7.26 19.26C7.26 21.847 9.41 24 12 24c2.58 0 4.698-2.138 4.698-4.74a2.574 2.574 0 0 1 2.562-2.562c2.588 0 4.74-2.11 4.74-4.698 0-2.58-2.137-4.698-4.74-4.698a2.574 2.574 0 0 1-2.562-2.562C16.698 2.153 14.588 0 12 0"
  })));
};
export default SvgQuatrefoil;